import React from 'react';
import ContentLayout from 'components/ContentLayout';

function CustomService() {
  return (
    <ContentLayout>
      <h1>Custom Service</h1>
    </ContentLayout>
  );
}

export default CustomService;
